import React from "react";
import Dropdown from "src/@components/input.dropdown";
import RoomPicker from "src/@components/input.room.picker";
import Accordion from "src/components/accordion";
import { ApplicationContext } from "src/context";

type DropdownRoomPickerProps = {
    rooms?: Array<GuestSelectorValue[]>;
    ageCategories: Array<TAgeCategory>;
    onChange: (rooms: Array<GuestSelectorValue[]>) => void;
    inputColor?: string;
    backgroundColor?: string;
    borderColor?: string;
};

export default class DropdownRoomPicker extends React.Component<DropdownRoomPickerProps> {

    /** @ts-ignore-next */
    public context!: React.ContextType<typeof ApplicationContext>;
    static contextType = ApplicationContext;

    static getDefaultValue(ageCategories: TAgeCategory[], overrides: Record<string, number>) {
        return RoomPicker.getDefaultValue(ageCategories, overrides);
    }

    render(): React.ReactNode {
        const inputLabel = RoomPicker.getHumanReadableQuantities(this.props.rooms, this.props.ageCategories, this.context);

        return <div className="relative">
        <Accordion removeChildrenWhenClosed={true} opener={<Dropdown className="max-w-none" placeholder={inputLabel} value={inputLabel} inputColor={this.props.inputColor} backgroundColor={this.props.backgroundColor} borderColor={this.props.borderColor} />}>
        <div className="absolute top-11 z-40 left-[50%] translate-x-[-150px] w-[300px] p-4 bg-white rounded-lg border border-slate-200 flex-col justify-center items-start gap-2 inline-flex shadow-lg">
            <RoomPicker rooms={this.props.rooms} onChange={this.props.onChange} ageCategories={this.props.ageCategories} />
        </div>
        </Accordion>
        </div>
    }
}